import EventManager from '../eventManager.mjs';
import { domToAST, resolveFullDOM } from '../helpers/iml.mjs';
import { registerCustomElement } from '../utils.mjs';
import events from '../events.mjs';
import { isAiBlock } from './aiBlock.mjs';

export class Pill extends HTMLElement {
	constructor() {
		super();

		this._built = false;
	}

	connectedCallback() {
		if (this._built) return;
		this._built = true;

		this.addEventListener('mouseenter', (event) => {
			if (this.hasAttribute('preview')) return;

			for (const node of resolveFullDOM(this, true)) {
				if (node.nodeType === 1) node.classList.add('hover');
			}
		});

		this.addEventListener('mouseleave', (event) => {
			if (this.hasAttribute('preview')) return;

			for (const node of this.parentNode.querySelectorAll('.hover')) {
				node.classList.remove('hover');
			}
		});

		if (!this.hasAttribute('draggable')) {
			this.setAttribute('draggable', 'true');
		}
		this.setAttribute('contenteditable', 'false');

		if (this.parentElement?.nodeName === 'IMT-CODER') {
			EventManager.dispatch(this, events.CODER.PILL_INSERTED, { bubbles: true });
		}
	}

	toIML({ keepUnwantedOperators = false } = { keepUnwantedOperators: false }) {
		const ast = domToAST(resolveFullDOM(this), keepUnwantedOperators);

		return IML.stringify(ast, undefined, { keepUnwantedOperators });
	}

	disconnectedCallback() {
		if (this._hintPanel && this._hintPanel.close) {
			this._hintPanel.close();
		}
	}

	getType() {
		const types = ['variable', 'function', 'operator', 'keyword', 'custom-variable'];

		return types.find((type) => this.classList.contains(type)) || null;
	}
}

let nodesAffectedByDrag;

document.addEventListener('dragstart', (event) => {
	if (!(event.target instanceof Pill)) return;

	if (event.target._hintPanel) {
		event.target._hintPanel.close();
		event.target._hintPanel = null;
	} else {
		const hintPanel = event.target.closest('imt-panel.coder-pills');

		if (hintPanel?.controller) {
			hintPanel.controller._hideHintPanel();
		}
	}

	nodesAffectedByDrag = resolveFullDOM(event.target);
	const iml = IML.stringify(domToAST(nodesAffectedByDrag, true), undefined, { keepUnwantedOperators: true });

	// console.log('DOM', nodesAffectedByDrag);
	// console.log('AST', domToAST(nodesAffectedByDrag, true), true);
	// console.log('IML', IML.stringify(domToAST(nodesAffectedByDrag, true), undefined, { keepUnwantedOperators: true }));

	// Prevent dragging when DOM didn't resolve in to IML
	if (!iml) return;

	event.dataTransfer.effectAllowed = 'copyMove';
	event.dataTransfer.setData('Text', iml); // ie/edge
	event.dataTransfer.setData('text/plain', iml); // browsers
	event.stopPropagation();
});

document.addEventListener('dragend', (event) => {
	if (!(event.target instanceof Pill)) return;

	nodesAffectedByDrag = null;
});

document.addEventListener('dragover', (event) => {
	if (!event.target.closest('imt-coder')) return event.preventDefault();

	if (Array.isArray(nodesAffectedByDrag) && nodesAffectedByDrag.length) {
		if (
			nodesAffectedByDrag[0].parentNode === event.target ||
			nodesAffectedByDrag[0].parentNode?.parentNode === event.target
		) {
			// Drag over the same coder field
			event.dataTransfer.dropEffect = 'move';
		} else {
			// Drag over different coder field
			event.dataTransfer.dropEffect = 'copy';
		}
	} else {
		event.dataTransfer.dropEffect = 'all';
	}
});

document.addEventListener('drop', (event) => {
	if (!event.target.closest('imt-coder')) return event.preventDefault();
	const isCopy = event.altKey || event.ctrlKey;

	if (!Array.isArray(nodesAffectedByDrag) || nodesAffectedByDrag.length === 0) {
		// No nodes to drop
		return;
	}

	if (
		!isCopy &&
		(nodesAffectedByDrag[0]?.parentNode?.nodeName === 'IMT-CODER' || isAiBlock(nodesAffectedByDrag[0]?.parentNode))
	) {
		for (const node of nodesAffectedByDrag) {
			if (node.parentNode) node.parentNode.removeChild(node);
		}
	}

	const form = event.target.closest('imt-forman');
	const element = nodesAffectedByDrag[0];

	if (element?.nodeName === 'IMT-PILL') {
		form?.tracking?.trackPillInserted({
			source: 'drag',
			variableName: element.getAttribute('name'),
			variableType: element.getType(),
			isBundle: element.classList.contains('bundle-pill'),
		});
	}
});

registerCustomElement('imt-pill', Pill);
